/*=========================================================================================
  File Name: state.js
  Description: Cart State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

import moment from 'moment'
export default {
    
    ADD_ITEM_STATE (state, payload) {

      //console.log('add item to cart');
      //console.log(payload.item)

      let shortDescription = '';
      let shortNames = [];

      payload.item.options.forEach(o => {
        for(let j = 0; j < o.options.length; j++) {
          shortNames.push(o.options[j].shortName);
        }
        
      });
      for (let i = 0;i < shortNames.length; i++) {
        if (shortNames.length - (i +1) > 0) {
          shortDescription += shortNames[i] + ' , ';
        }
        else {
          shortDescription += shortNames[i];
        }
      }

      let newItem = {
        index : -1,
        itemId : payload.item.itemId,
        itemName : payload.item.itemName,
        itemPrice : payload.item.itemPrice,
        addedPrice : payload.item.addedPrice,
        discount : payload.item.discount,
        baseDiscount : payload.item.discount,
        tax : payload.item.tax,
        quantity : 1,
        categoryName : payload.item.categoryName,
        isCustomized : payload.item.isCustomized,
        groupOptionsModel : payload.item.groupOptionsModel,
        estimatedTime : payload.item.estimatedTime,
        options : payload.item.options,
        comment : payload.item.comment,
        imageUrl : payload.item.imageUrl,
        shortDescription : shortDescription
      }
      if (state.discountCode) {
        newItem.discount = state.discountCode.percent;
      }
      if(newItem.isCustomized) {
        let index = state.selectedItems.length;
        newItem.index = index;
        state.selectedItems.push(newItem);
      }
      else {
        let index = state.selectedItems.findIndex(i => { return newItem.itemId === i.itemId && !i.isCustomized});
        if (index > -1) {
          state.selectedItems[index].quantity++;
        }
        else {
          let nextIndex = state.selectedItems.length;
          newItem.index = nextIndex;
          state.selectedItems.push(newItem);
        }
      }
      //console.log(newItem)
      //state.estimatedTime += newItem.estimatedTime;
      state.amount += newItem.itemPrice;
    },

    UPDATE_ITEM_STATE (state, payload) {

      //
      //replace old options with new options
      //
      payload.selectedOptions.forEach(o => {
        
        let index = state.selectedItems[payload.index].options.findIndex(i => {
          return i.codeName === o.codeName
        });
       

        if (index > -1) {
          
          state.selectedItems[payload.index].options[index] = o;
        }
        else {
        
          state.selectedItems[payload.index].options.push(o)
        }

      });

      // 
      //update price
      //
      if(state.selectedItems[payload.index].options.length > 0) {
        let price = 0.0;
        state.selectedItems[payload.index].options.forEach(o => {
          price += o.addedPrice
        });

      //
      //update options
      //

      let shortDescription = '';
      let shortNames = [];

      state.selectedItems[payload.index].options.forEach(o => {
        for(let j = 0; j < o.options.length; j++) {
          shortNames.push(o.options[j].shortName);
        }
      });
      for (let i = 0;i < shortNames.length; i++) {
        if (shortNames.length - (i +1) > 0) {
          shortDescription += shortNames[i] + ' , ';
        }
        else {
          shortDescription += shortNames[i];
        }
      }


      state.selectedItems[payload.index].addedPrice = price;
      //state.selectedItems[payload.index].options = payload.selectedOptions;
      state.selectedItems[payload.index].shortDescription = shortDescription;
      state.selectedItems[payload.index].isCustomized = true;
      }
      
   },

    REMOVE_ITEM_STATE (state, payload) {
      console.log('remove item from cart');
      let index = state.selectedItems.findIndex(i => {
        return payload.itemId === i.itemId;
      });
      if (index > -1) {
        state.selectedItems.splice(index, 1);
        //
        //update index
        //
        for(let i = 0; i < state.selectedItems.length; i++) {
          state.selectedItems[i].index = i;
        }
      }
     
    },

    REMOVE_ITEM_OPTIONS_STATE (state, payload) {
      console.log('remove options from item');
      let index = state.selectedItems.findIndex(i => {
        return payload.itemId === i.itemId;
      });
      if (index > -1) {
        state.selectedItems.splice(index, 1);
      }
    },

    UPDATE_ESTIMATED_TIME_STATE (state, payload) {
      console.log('UPDATE_ESTIMATED_TIME_STATE');
      let totalSeconds = 0;

      state.selectedItems.forEach(o => {
        totalSeconds += (o.estimatedTime * o.quantity);
      })
      console.log('Total seconds: ' + totalSeconds);
      let totalMinutes = Math.ceil((totalSeconds / 60));
      console.log('Total minutes:' + totalMinutes) 
      state.estimatedTime = totalMinutes;
    },

    UPDATE_ESTIMATED_PICKUPTIME_STATE (state, payload) {
      console.log('UPDATE_ESTIMATED_PICKUPTIME_STATE');
      let realEstimatedTime = state.estimatedTime;
      let estimatedPickupTime = moment();
    
      if (realEstimatedTime <= payload.minWaitingTime) {
        realEstimatedTime = payload.minWaitingTime;
      }
      if(realEstimatedTime >= payload.maxWaitingTime) {
        realEstimatedTime = payload.maxWaitingTime;
      }

      //
      //update pickup time according to new estimated time
      //
      estimatedPickupTime.add(realEstimatedTime, 'minutes');
      state.pickupTime = estimatedPickupTime;
    },


    APPLY_DISCOUNT_CODE_STATE (state, payload) {
      state.discountCode = { code : payload.code, percent : payload.percent };
      state.selectedItems.forEach(item => {
        item.discount = payload.percent;
      });
    },

    CLEAR_DISCOUNT_CODE_STATE (state) {
      state.discountCode = null;
      state.selectedItems.forEach(item => {
        item.discount = typeof item.baseDiscount === 'number' ? item.baseDiscount : 0;
      });
    },

    CLEAR_CART_STATE (state) {
      console.log('cart is cleared!');
      state.selectedItems = [];
      state.discountCode = null;
      state.orderInfo = {
        customerName : '',
        email : '',
        phoneNumber : '',
        comment : '',
        waitingTime : null,
        pickupTime : null, 
        asap : false
      }
    },

    SET_CART_STATE (state, payload) {
      console.log(payload)
      state.selectedItems = payload.selectedItems;
      
    },

    SET_ORDER_INFO_STATE (state, payload) {
      state.orderInfo.customerName = payload.customerName;
      state.orderInfo.email = payload.email;
      state.orderInfo.phoneNumber = payload.phoneNumber;
      state.orderInfo.comment = payload.comment;
      state.orderInfo.waitingTime = payload.waitingTime;
      state.orderInfo.pickupTime = payload.pickupTime;
      state.orderInfo.asap = payload.asap;
    },

    SET_CART_INFO_STATE (state, payload) {
      state.selectedItems =  payload.cart;
      //state.estimatedTime = payload.waitingTime;
      state.amount = payload.amount;
      console.log('UPDATE_ESTIMATED_TIME_STATE');
      let totalSeconds = 0;

      state.selectedItems.forEach(o => {
        totalSeconds += (o.estimatedTime * o.quantity);
      })
      console.log('Total seconds: ' + totalSeconds);
      let totalMinutes = Math.ceil((totalSeconds / 60));
      console.log('Total minutes:' + totalMinutes) 
      state.estimatedTime = totalMinutes;
    },

    SET_CUSTOMER_INFO(state, payload) {
     
      state.orderInfo.customerName = payload.customerName
      state.orderInfo.email = payload.email
      state.orderInfo.phoneNumber = payload.phoneNumber
    },

    SET_COMMENT_STATE(state, payload) {
      state.orderInfo.comment = payload;
    }
   

}